var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 79,
    viewBox: "0 0 76 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.059,
    height: 41.0587,
    rx: 5,
    transform: "matrix(1 0 0.00205883 0.999998 0 37)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5283 3.52826C48.5756 1.57564 45.4131 1.57889 43.4645 3.53553L22.2949 24.7924C20.3463 26.7491 20.3496 29.9182 22.3022 31.8708L43.4714 53.04C45.4241 54.9926 48.5866 54.9893 50.5352 53.0327L71.7048 31.7758C73.6534 29.8192 73.6501 26.6501 71.6975 24.6975L50.5283 3.52826ZM50.5316 16.0549C48.579 14.1023 45.4164 14.1055 43.4678 16.0621L34.7958 24.7698C32.8472 26.7264 32.8505 29.8955 34.8031 31.8481L43.4684 40.5134C45.421 42.466 48.5836 42.4628 50.5322 40.5061L59.2041 31.7985C61.1527 29.8418 61.1495 26.6728 59.1968 24.7201L50.5316 16.0549Z",
    fill: "#FF001D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.7cdfed168e5f367757a321b8326692fb.svg";
export { ForwardRef as ReactComponent };